module.exports = __webpack_public_path__ + "img/9_33.09c492b6.png";